import { render, staticRenderFns } from "./datagridTable.vue?vue&type=template&id=7680bafd&"
import script from "./datagridTable.vue?vue&type=script&lang=js&"
export * from "./datagridTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/datagridTable.vue"
export default component.exports